import React from 'react'

const ArrowsIcon = () => {
	return (
		<svg width={17} height={14} viewBox='0 0 17 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path d='M6 13L1 6.867 6 1M11 13L6 6.867 11 1M16 13l-5-6.133L16 1' stroke='currentColor' />
		</svg>
	)
}

export default ArrowsIcon
